export default __webpack_public_path__ + "static/media/premium_plus.cb6cf5c8.svg";